// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mimer-button{border-radius:.25rem;border-style:none;display:block;font-size:1rem;line-height:1.5rem;max-width:32rem;padding:1rem;text-align:center;color:#fff;width:100%;background-color:#951b81;font-family:system,Segoe UI,Tahoma,-apple-system;cursor:pointer}.mimer-button:hover{opacity:.9}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
